function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import Modal from '@mui/material/Modal';
import { ArrowBack, Close as CloseIcon } from '@mui/icons-material';
import Text from '../../components/Text.js';
import Button from '../../components/Button.js';
import * as Theme from '../../theme/index.js';
import Content from '../../components/Content.js';
import { styled } from '@mui/system';
import csvImage from '../../assets/csv.png';
import docImage from '../../assets/doc.png';
import imgImg from '../../assets/img.png';
import jsonImg from '../../assets/json.png';
import pdfImg from '../../assets/pdf.png';
import xlsImg from '../../assets/xls.png';
const {
  globalStyles
} = Theme;
const StyledPreviewStyle = styled('div')(({
  theme
}) => ({
  minHeight: '315px',
  minWidth: '285px',
  backgroundColor: Theme.colors.surface,
  borderRadius: '8px',
  padding: '10px',
  marginLeft: '5px',
  margin: '5px',
  wordBreak: 'break-all',
  [theme.breakpoints.down('666')]: {
    minWidth: 'fit-content'
  }
}));
class MassUpdateDropZoneModal extends Component {
  state = {
    showContactModal: false,
    files: [],
    fileName: '',
    showDropzone: true,
    type: null
  };
  _chooseDocument = async files => {
    if (!this.props.acceptMultiple && files[1] !== null) {
      files = await new Array(files[0]);
    }
    const valid = files[0];
    if (!valid) {
      // TODO: display message
      return false;
    }
    const duplicate = this.state.files.length > 0 && this.state.files[0].name === files[0].name;
    if (valid && !duplicate) {
      this.setState({
        fileName: files[0].name,
        files: [...this.state.files, ...files]
      });
    }
    await this.setState({
      showDropzone: this.state.files.length < this.props.maxItems
    });
    return true;
  };
  _fileType = file => {
    let fileType = null;
    switch (file.type) {
      case 'application/xlsx':
        fileType = xlsImg;
        break;
      case 'application/vnd.ms-excel':
        fileType = xlsImg;
        break;
      case 'text/csv':
        fileType = csvImage;
        break;
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        fileType = docImage;
        break;
      case 'image/jpeg':
        fileType = imgImg;
        break;
      case 'image/jpg':
        fileType = imgImg;
        break;
      case 'image/png':
        fileType = imgImg;
        break;
      case 'application/json':
      case 'text/json':
        fileType = jsonImg;
        break;
      default:
        fileType = pdfImg;
        break;
    }
    return fileType;
  };
  _fileName = file => {
    let filename = null;
    file.name.length > 25 ? filename = `${file.name.substr(0, 11)}...${file.name.substr(-11)}` : filename = file.name;
    return filename;
  };
  _removeDocument = async name => {
    const fileArray = this.state.files.filter(file => file.name !== name);
    await this.setState({
      files: fileArray,
      showDropzone: true
    });
  };
  _submitDocument = async (skipClose = null) => {
    if (this.state.files.length > 0) {
      const submit = await this.props.submitFile(this.state.files, this.props.type);
      if (skipClose !== true) {
        this.props.hideModal();
      }
      return submit;
    }
    return null;
  };
  handleKeyPress = event => {
    if (event.key === 'Enter') {
      return this._submitDocument();
    }
    return false;
  };
  render() {
    const {
      showModal,
      hideModal,
      title,
      acceptedFiles,
      testid,
      instructions,
      warning,
      skipClose,
      subText,
      onBack,
      fieldNames,
      errors = null
    } = this.props;
    const {
      showDropzone
    } = this.state;
    const styles = {
      goBackIcon: {
        cursor: 'pointer',
        fontSize: '22px',
        marginRight: 1.25,
        display: 'inline',
        marginTop: '5px',
        float: 'left',
        color: Theme.colors.mainTextGrey
      },
      container: globalStyles.container,
      content: globalStyles.content,
      btnWidth: {
        width: 'fit-content',
        marginLeft: 'auto'
      },
      modal: {
        top: '50%',
        left: '50%',
        margin: '0',
        maxWidth: '40%',
        minWidth: '648px',
        outline: 'none',
        position: 'absolute',
        boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
        borderRadius: '12px',
        transform: 'translate(-50%, -50%)',
        WebkitTransform: 'translate(-50%, -50%)'
      },
      modalBody: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        borderRadius: '12px',
        padding: '20px',
        backgroundColor: Theme.colors.surface
      },
      closeModalIcon: {
        cursor: 'pointer',
        display: 'inline',
        marginTop: '5px',
        fontSize: '22px',
        float: 'right',
        color: Theme.colors.mainTextGrey
      },
      titleIconWrapper: {
        display: 'block',
        width: '100%',
        verticalAlign: 'center'
      },
      cardStyle: {
        backgroundColor: Theme.colors.lightBlue,
        boxShadow: 'none',
        padding: '20px',
        border: `2px dotted ${Theme.colors.mediumBlue}`,
        borderRadius: '8px',
        textAlign: 'center',
        color: Theme.colors.mediumBlue
      },
      cardDisabled: {
        backgroundColor: Theme.colors.lightGrey,
        boxShadow: 'none',
        padding: '20px',
        border: `2px dotted ${Theme.colors.mediumLightGrey}`,
        borderRadius: '8px',
        color: Theme.colors.mediumLightGrey
      },
      previewWrapper: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        alignItems: 'center',
        marginBottom: '10px',
        backgroundColor: Theme.colors.lightGrey,
        boxShadow: 'none',
        padding: '5px',
        borderRadius: '8px'
      },
      fileTitle: {
        maxWidth: '300px',
        wordBreak: 'break-all'
      },
      logo: globalStyles.logo
    };
    return /*#__PURE__*/React.createElement(Modal, {
      open: showModal,
      onClose: hideModal,
      style: {
        overflow: 'auto',
        'WebkitOverflowScrolling': 'touch'
      }
    }, /*#__PURE__*/React.createElement(Content, {
      style: styles.modal,
      onKeyPress: this.handleKeyPress
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.modalBody
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.titleIconWrapper
    }, onBack && /*#__PURE__*/React.createElement(ArrowBack, {
      onClick: onBack,
      sx: styles.goBackIcon
    }), /*#__PURE__*/React.createElement(CloseIcon, {
      style: styles.closeModalIcon,
      onClick: hideModal
    }), /*#__PURE__*/React.createElement(Text, {
      align: "center",
      bold: true,
      mediumLarge: true,
      display: "inline-block",
      margin: "0"
    }, title), subText ? /*#__PURE__*/React.createElement(Text, {
      light: true,
      small: true,
      margin: "0px 0px 20px 0px"
    }, subText) : null), instructions && /*#__PURE__*/React.createElement("div", {
      style: styles.titleIconWrapper
    }, /*#__PURE__*/React.createElement(Text, {
      align: "left",
      display: "inline-block",
      margin: "0",
      small: true
    }, instructions)), this.props.downloadTemplate && /*#__PURE__*/React.createElement(Button, {
      onClick: this.props.downloadTemplate,
      transparent: true,
      customStyle: {
        width: "100%"
      }
    }, "Download blank template"), warning && /*#__PURE__*/React.createElement("div", {
      style: styles.titleIconWrapper
    }, /*#__PURE__*/React.createElement(Text, {
      align: "left",
      bold: true,
      medium: true,
      display: "inline-block",
      margin: "0",
      color: Theme.colors.red
    }, warning)), !errors ? /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: '20px',
        maxHeight: '200px',
        overflowY: 'scroll'
      }
    }, fieldNames.map(name => /*#__PURE__*/React.createElement(Text, {
      key: name,
      small: true,
      margin: "0 0 0 20px"
    }, "\u2022\xA0\xA0", name))) : null, errors ? /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: '20px',
        maxHeight: '200px',
        overflowY: 'scroll'
      }
    }, Object.values(errors).map(error => /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 10
      },
      key: error.index
    }, /*#__PURE__*/React.createElement(Text, {
      color: "red"
    }, `Record for ${error.index} failed for the following reason(s): `), error.failureVerbiages.map(verbiage => /*#__PURE__*/React.createElement(Text, {
      key: verbiage,
      small: true,
      margin: "0 0 0 20px"
    }, "\u2022\xA0\xA0", verbiage))))) : null, this.state.files.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      style: styles.previewWrapper
    }, this.state.files.map(file => {
      const fileType = this._fileType(file);
      const fileName = this._fileName(file);
      return /*#__PURE__*/React.createElement(StyledPreviewStyle, {
        key: file.name
      }, /*#__PURE__*/React.createElement(CloseIcon, {
        style: styles.closeModalIcon,
        onClick: () => this._removeDocument(file.name)
      }), /*#__PURE__*/React.createElement("img", {
        alt: "File type icon",
        src: fileType,
        style: styles.logo
      }), /*#__PURE__*/React.createElement(Text, {
        align: "center",
        bold: true,
        mediumLarge: true,
        display: "block",
        margin: "0",
        customStyle: {
          maxWidth: 300
        }
      }, fileName));
    }))), this.state.showDropzone && /*#__PURE__*/React.createElement(Dropzone, {
      onDrop: files => this._chooseDocument(files),
      accept: acceptedFiles || "image/png, image/jpeg, image/jpg, text/csv, .csv, .xls, .xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }, ({
      getRootProps,
      getInputProps
    }) => /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("div", _extends({}, getRootProps(), {
      style: !showDropzone ? styles.cardDisabled : styles.cardStyle
    }), /*#__PURE__*/React.createElement("input", getInputProps()), /*#__PURE__*/React.createElement(Text, {
      testid: testid,
      color: "skyBlue",
      margin: "20px 0",
      small: true,
      align: "center"
    }, "Drag and drop your files here, or click to select...")))), acceptedFiles && /*#__PURE__*/React.createElement(Text, {
      margin: "10px 0 0",
      align: "center",
      tiny: true
    }, acceptedFiles), /*#__PURE__*/React.createElement(Button, {
      disabled: this.state.files.length === 0,
      onClick: () => this._submitDocument(skipClose),
      color: "primary",
      customStyle: styles.btnWidth,
      marginTop: "20px"
    }, "Submit"))));
  }
}
export default connect()(MassUpdateDropZoneModal);